import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import EfdPrivateRoutes from './efd-private-routes';

import { fetchApps } from './common/actions/apps-action-creators';
import { logout } from './common/actions/authentication-action-creators';
import { fetchCollections } from './dashboard/actions/dashboard-action-creators';
import { fetchDomainGroups } from './common/actions/domain-groups-action-creators';
import { fetchDomains } from './common/actions/domains-action-creators';
import {
    fetchFeatureFlags,
    redirectToLogout,
    switchSideNavItems
} from './common/actions/ui-state-action-creators';

import { appItemsSelector } from './common/selectors/apps-selectors';
import {
    endUserAuthApiSelector,
    navBarMessageSelector
} from './common/selectors/app-config-selectors';
import {
    hasGlobalAccessSelector,
    hasNewFeatureVisibilitySelector,
    userNameAndLocationSelector
} from './common/selectors/auth-selectors';
import {
    isExperimentalSelector,
    isInitialLoadSelector,
    isMaintenanceFlagSelector,
    isSessionValidSelector,
    sideNavItemsSelector,
} from './common/selectors/ui-state-selectors';
import {
    rightPaneVariantSelector,
    rightPaneIsOpenSelector,
} from './common/selectors/right-pane-selectors';

class EFDPrivateRouteContainer extends React.Component{
    constructor( props ){
        const {
            fetchApps,
            fetchFeatureFlags,
            fetchCollections,
            fetchDomainGroups,
            fetchDomains,
            isExperimental,
        } = props;
        super( props );
        fetchFeatureFlags();
        [ 'prod', 'staging' ].indexOf( process.env.REACT_APP_STAGE ) < 0 && fetchApps();
        isExperimental && fetchCollections();
        isExperimental && fetchDomainGroups();
        fetchDomains();
    }
    render(){
        const {
            appItems,
            endUserAuthApi,
            hasGlobalAccess,
            hasNewFeatureVisibility,
            isExperimental,
            logout,
            navBarMessage,
            redirectToLogout,
            rightPaneIsOpen,
            rightPaneVariant,
            sideNavItems,
            switchSideNavItems,
            userInfo,
        } = this.props;
        return (
            <EfdPrivateRoutes
                appItems={appItems}
                endUserAuthApi={endUserAuthApi}
                isExperimental={isExperimental}
                hasNewFeatureVisibility={hasNewFeatureVisibility}
                logout={ hasGlobalAccess ? logout : redirectToLogout}
                navBarMessage={navBarMessage}
                rightPaneVariant={rightPaneVariant}
                rightPaneIsOpen={rightPaneIsOpen}
                sideNavItems={sideNavItems}
                switchSideNavItems={switchSideNavItems}
                userInfo={userInfo}
            />
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        appItems: appItemsSelector( state ),
        endUserAuthApi: endUserAuthApiSelector( state ),
        hasGlobalAccess: hasGlobalAccessSelector( state ),
        hasNewFeatureVisibility: hasNewFeatureVisibilitySelector( state ),
        isExperimental: isExperimentalSelector( state ),
        isInitialLoad: isInitialLoadSelector( state ),
        isSessionValid: isSessionValidSelector( state ),
        maintenanceFlag: isMaintenanceFlagSelector( state ),
        navBarMessage: navBarMessageSelector( state ),
        rightPaneIsOpen: rightPaneIsOpenSelector( state ),
        rightPaneVariant: rightPaneVariantSelector( state ),
        sideNavItems: sideNavItemsSelector( state ),
        userInfo: userNameAndLocationSelector( state ),
    };
};

const mapDispatchToProps = {
    fetchApps,
    fetchCollections,
    fetchDomainGroups,
    fetchDomains,
    fetchFeatureFlags,
    logout,
    redirectToLogout,
    switchSideNavItems,
};

EFDPrivateRouteContainer.propTypes = {
    appItems: PropTypes.array,
    endUserAuthApi: PropTypes.string.isRequired,
    fetchApps: PropTypes.func.isRequired,
    fetchCollections: PropTypes.func.isRequired,
    fetchDomainGroups: PropTypes.func.isRequired,
    fetchDomains: PropTypes.func.isRequired,
    fetchFeatureFlags: PropTypes.func.isRequired,
    hasGlobalAccess: PropTypes.bool.isRequired,
    hasNewFeatureVisibility: PropTypes.bool.isRequired,
    isExperimental: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    navBarMessage: PropTypes.string,
    redirectToLogout: PropTypes.func.isRequired,
    rightPaneIsOpen: PropTypes.bool,
    rightPaneVariant: PropTypes.string,
    sideNavItems: PropTypes.array,
    switchSideNavItems: PropTypes.func.isRequired,
    userInfo: PropTypes.object,
};

export default connect( mapStateToProps, mapDispatchToProps )( EFDPrivateRouteContainer );
